export default "__VITE_ASSET__4e94e5c3__"